import * as SearchCriteriasStyle from '../../../styles/events/search-criterias.module.scss';
import * as popUpStyles from '../../../styles/layout/search-pop-up.module.scss';
import { PropTypes } from 'prop-types';
import IconContainer from '../IconContainer';
import React from 'react';
import {useTranslation} from 'react-i18next';

const Search = React.memo(function Search ({
  getSearchWords, height, padding, italic, placeholder, initalSearch,
}) {
  const [searchWord, setSearchWord] = React.useState(initalSearch || '');
  const {t} = useTranslation();

  function updateSearchValue (value) {
    setSearchWord(value);
    getSearchWords(value);
  }

  function getFocus () {
    if (typeof window !== 'undefined') {
      if (document.querySelector('input[name=\'search\']')) {
        document.querySelector('input[name=\'search\']').focus();
      }
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      updateSearchValue('');
      getFocus();
    }
  };

  return (
    <div className={SearchCriteriasStyle.searchContainer}>
      <div
        className={popUpStyles.search}
        style={height || padding ? {height: height, padding: padding} : {}}
      >
        <div className={popUpStyles.inputContainer}>
          <div className={popUpStyles.searchIconItem}>
            <IconContainer color="BLACK"
              icon="SEARCH"
              noHover
              size={25}
              tabIndex={-1}
            />
          </div>
          <div className={popUpStyles.inputItem}>
            <input
              aria-label={t('search.window.search')}
              className={popUpStyles.input}
              name='search'
              onChange={(event) => updateSearchValue(event.target.value)}
              placeholder={placeholder || t('search.bar')}
              style={italic ? {
                fontSize: 15, fontWeight: 500, fontStyle: 'italic', outline: 0, width: '90%',
              } : {outline: 0, width: '90%'}}
              tabIndex="0"
              title={placeholder || t('search.bar')}
              value={searchWord}
            />
          </div>
        </div>
        <button
          className={popUpStyles.closeContainer}
          onClick={() => {
            updateSearchValue('');
            getFocus();
          }}
          onKeyDown={handleKeyDown}
          tabIndex="-1"

        >
          <IconContainer
            aria-label={t('search.window.close')}
            color="BLACK"
            icon="MENU_CLOSE"
            label={t('search.clear')}
            notHidden
            size={10}
            tabIndex="0"
          />
        </button>
      </div>
    </div>
  );
});

Search.propTypes = {
  getSearchWords: PropTypes.func.isRequired,
  height: PropTypes.number,
  initalSearch: PropTypes.string,
  italic: PropTypes.bool,
  padding: PropTypes.number,
  placeholder: PropTypes.string,
};

export default Search;
